import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { useNavigate } from "react-router-dom";
import { ROUTE_SUPER_ADMIN } from "../../Util/VMConstants";

export default function SuperAdminPageHeader({ title, showBack = true, actions, sx, mb = 2 }) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate(`/${ROUTE_SUPER_ADMIN}`);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 2,
        mb,
        ...sx,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, minWidth: 0 }}>
        {showBack ? (
          <IconButton
            onClick={handleBack}
            aria-label="Go back"
            size="small"
            sx={{ color: "primary.main", mr: 0.5 }}
          >
            <ArrowBackRoundedIcon />
          </IconButton>
        ) : null}
        <Typography variant="pageTitle" sx={{ fontWeight: 600, color: "primary.main" }}>
          {title}
        </Typography>
      </Box>
      {actions ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>{actions}</Box>
      ) : null}
    </Box>
  );
}
